import MuiListItemButton from "@mui/material/ListItemButton";
import MuiTypography from "@mui/material/Typography";

import { styled } from "@mui/material";

export const ListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== "isCollapsed" && prop !== "isActive",
})<{ isCollapsed: boolean; isActive: boolean }>(({ theme, isActive }) => ({
  marginBottom: "8px",
  minHeight: 44,
  color: isActive ? theme.colors.blue600 : theme.colors.grey700,
  transition: theme.transitions.create(
    ["padding", "border-radius", "background-color", "color"],
    {
      easing: theme.transitions.easing.easeInOut,
      duration: 200,
    },
  ),
  "&.Mui-selected": {
    backgroundColor: isActive ? theme.colors.blue100 : theme.colors.grey000,
  },

  "& svg": {
    width: 20,
    height: 20,
    minWidth: 20,
    minHeight: 20,
    flexShrink: 0,
    transition: "none",
  },

  variants: [
    {
      props: ({ isCollapsed }: { isCollapsed: boolean }) => isCollapsed,
      style: {
        padding: "12px",
        borderRadius: "50%",
      },
    },
    {
      props: ({ isCollapsed }: { isCollapsed: boolean }) => !isCollapsed,
      style: {
        padding: "12px 20px",
        borderRadius: "40px",
      },
    },
  ],
}));

export const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== "isCollapsed" && prop !== "isActive",
})<{ isCollapsed: boolean; isActive: boolean }>(({ theme, isActive }) => ({
  marginLeft: "12px",
  marginRight: "12px",
  color: isActive ? theme.colors.blue600 : theme.colors.grey800,

  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  transition: "max-width 200ms ease, opacity 160ms ease, margin 200ms ease",

  variants: [
    {
      props: ({ isCollapsed }: { isCollapsed: boolean }) => isCollapsed,
      style: {
        maxWidth: 0,
        opacity: 0,
        marginLeft: 0,
        marginRight: 0,
      },
    },
  ],
}));
